import { defineComponent as _defineComponent } from 'vue'

import { defineComponent, Component, computed, ref, watch } from 'vue';
export interface ITabItems {
  tabName: string;
  component: Component;
  props: Record<string, any>;
  on?: Record<string, any>;
  tabId: string;
}
const __default__ = defineComponent({
  name: 'TabbedSection',
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    tabItems: null,
    tabsContainerClass: { default: '' },
    activeTab: { default: 0 }
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as { tabItems: ITabItems[], tabsContainerClass: string, activeTab: number };




const selectedTab = ref<number>(props.activeTab ?? 0);

watch(
  () => props.activeTab,
  (newVal) => {
    selectedTab.value = newVal;
  },
);

const tabItems = computed(() => props.tabItems);

return { __sfc: true,emit, props, selectedTab, tabItems }
}

})